import cryptoJs from "crypto-js";

/**
 * Hash of the canonical source text a translation was written against.
 *
 * Not identity — that is the element key. It guards a row from applying once the
 * element's live text no longer hashes to it, and selects between rows that exist for
 * one (element, slot, locale) at different hashes.
 *
 * `crypto-js` rather than `node:crypto`, because the localization Liquid tag hashes its
 * own body and is registered in `createCepLiquidEngine`, which the browser preview also
 * builds. Digests are byte-identical to `createHash("sha256").update(text, "utf8")`.
 */
export function sourceHash(text: string): string {
  return cryptoJs.SHA256(substituteLoneSurrogates(text)).toString();
}

const LONE_SURROGATE_RE =
  /[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g;

/**
 * What keeps the digests above byte-identical, and what keeps a subject truncated
 * mid-emoji from failing its save: `crypto-js` parses UTF-8 through
 * `unescape(encodeURIComponent(…))`, which throws on an unpaired surrogate where Node
 * substitutes U+FFFD.
 */
function substituteLoneSurrogates(text: string): string {
  return text.replace(LONE_SURROGATE_RE, "�");
}
